// extracted by mini-css-extract-plugin
export default {"form":"CooperationForm_form__OG6w0","title":"CooperationForm_title__vtFHE","text":"CooperationForm_text__AINwO","bg":"CooperationForm_bg__2QPUC","btn":"CooperationForm_btn__L+ZYw"};